'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gsap = require('gsap');

var _ScrollTrigger = require('gsap/ScrollTrigger');

_gsap.gsap.registerPlugin(_ScrollTrigger.ScrollTrigger);

exports.default = {
  init: function init() {
    this.fixedHeader();
    this.lazyLoad();
    this.reveal();
    this.inViewProgressBars();
  },
  fixedHeader: function fixedHeader() {
    var notificationBar = document.querySelector('.site-notification');

    if (notificationBar) {
      document.documentElement.style.setProperty('--notification-bar-height', notificationBar.offsetHeight + 'px');
    }

    _ScrollTrigger.ScrollTrigger.create({
      start: 'top -100',
      end: 99999,
      toggleClass: { className: 'is-scrolled', targets: ['.site-header', '.site-register-bar'] }
    });
  },
  lazyLoad: function lazyLoad() {
    var lazyItems = document.querySelectorAll('.lazy');

    if (!lazyItems || lazyItems.length === 0) return;

    lazyItems.forEach(function (item) {
      _ScrollTrigger.ScrollTrigger.config({
        ignoreMobileResize: true
      });

      _ScrollTrigger.ScrollTrigger.create({
        trigger: item,
        start: '-50% bottom',
        once: true,
        onEnter: function onEnter() {
          if (item.classList.contains('lazy-bg')) {
            item.style = 'background-image: url(' + item.dataset.bg + ')';
          } else {
            item.src = item.dataset.src;
          }
        }
      });
    });
  },
  inViewCounters: function inViewCounters() {
    var counter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (!counter || typeof counter === 'undefined') return;
    var speed = 5000;

    var animate = function animate() {
      var value = +counter.dataset.countTarget;
      var data = +counter.innerText;
      var time = value / speed;

      if (data < value) {
        counter.innerText = Math.ceil(data + time);
        setTimeout(animate, 50);
      } else {
        counter.innerText = value;
      }
    };

    _ScrollTrigger.ScrollTrigger.create({
      trigger: counter,
      start: 'top bottom-=10%',
      once: true,
      onEnter: function onEnter() {
        animate(counter);
      }
    });
  },
  reveal: function reveal() {
    var items = document.querySelectorAll('[data-reveal]');

    if (items && items.length > 0) {
      items.forEach(function (item) {
        _ScrollTrigger.ScrollTrigger.create({
          trigger: item,
          start: 'top 80%',
          once: true,
          toggleClass: 'reveal-animate'
        });
      });
    }
  },
  inViewProgressBars: function inViewProgressBars() {
    var bars = document.querySelectorAll('.stages-progress-bar');

    if (!bars || bars.length === 0) return null;

    bars.forEach(function (bar) {
      _ScrollTrigger.ScrollTrigger.create({
        trigger: bar,
        start: 'top bottom-=10%',
        toggleClass: 'in-view'
      });
    });
  }
};


// WEBPACK FOOTER //
// ./scripts/components/scrollEvents.js